import { z } from "zod";

const schema = z.object({
    projects: z.array(
        z.object({
            projectId: z.string().min(1, { message: "Required" }),
            name: z.string().min(1, { message: "Required" }),
            base: z.object({
                name: z.string().min(1, { message: "Required" }),
                id: z.string().min(1, { message: "Required" }),
            })
           
        })
    ).optional(),
})

type schemaType = z.infer<typeof schema>;

export {
    schema,
    type schemaType
}
